// extracted by mini-css-extract-plugin
export default {"icon":"Header_icon__sdY8F","menuIcon":"Header_menuIcon__DpekX","link":"Header_link__RHWgd"};